// Miroir de IASVMobile/constants/roles.js — gardez les deux fichiers synchrones.
export const ROLES = {
  ADMIN: 'admin',
  COACH: 'coach',
  PLAYER: 'player',
  SUPPORTER: 'supporter',
};

export const ROLE_LABELS = {
  [ROLES.ADMIN]: 'Administrateur',
  [ROLES.COACH]: 'Entraîneur',
  [ROLES.PLAYER]: 'Joueur',
  [ROLES.SUPPORTER]: 'Supporter',
};

export default ROLES;
